import { Injectable }               from '@angular/core';
import {
	RequestCompleteEntityState,
	RequestState
}                                   from '@core/interfaces/api.interface';
import { DialogModalCommonService } from '@core/modals/dialog-modal-common/dialog-modal-common.service';
import { TranslationService }       from '@core/services/translation.service';
import {
	IStatusFlowOptions,
	StatusFlowEntityType,
	StatusFlowTextModeEnum
}                                   from '@shared/components/status-flow/status-flow.model';
import { ToasterService }           from '@shared/services/toaster.service';
import { UiService }                from '@shared/services/ui.service';
import { of }                       from 'rxjs';
import {
	switchMap,
	take
}                                   from 'rxjs/operators';

@Injectable( { providedIn: 'root' } )
export class StatusFlowService {

	constructor(
		private readonly dialogCommonService: DialogModalCommonService,
		private readonly translationService: TranslationService,
		private readonly uiService: UiService,
		private readonly toasterService: ToasterService
	) {}

	public changeStatus(
		statusFlowOptions: IStatusFlowOptions
	): void {
		const {
			callback,
			callbackOptions,
			caller,
			descriptionSuffix,
			enforceDialogText,
			entity,
			entityService,
			entityId,
			statusChangeEvent
		} = { ...statusFlowOptions };

		let dialogConfirmationText =
			this.translationService.getI18nString(
				false,
				null,
				`${ statusChangeEvent?.dialog?.i18nPathDescription }${ descriptionSuffix ?? '' }`,
				true,
				''
			);

		let htmlString: string;

		// if enforce dialog is set and has type plain, we need to overwrite dialogConfirmationText
		if ( enforceDialogText?.type === StatusFlowTextModeEnum.PLAIN ) {
			dialogConfirmationText = enforceDialogText.text;
		} else if ( enforceDialogText?.type === StatusFlowTextModeEnum.HTML ) {
			htmlString = enforceDialogText.text;
			dialogConfirmationText = null;
		}

		this.dialogCommonService.showConfirmationDialog(
			dialogConfirmationText,
			statusChangeEvent?.dialog?.i18nPathButtonConfirm,
			null,
			htmlString,
			statusChangeEvent?.dialog?.i18nPathButtonCancel
		)
		.pipe(
			take( 1 ),
			switchMap( () => {
				this.uiService.showPageLoaderAndCountUp();
				return entityService?.read( { id: entity.id, presetId: callbackOptions.presetId, storeConfig: { updateStore: false }, withFullResponse: true } );
			} ),
			switchMap( ( readState: RequestCompleteEntityState<StatusFlowEntityType> ) => {
				return readState.requestState === RequestState.SUCCESS
							 ? entityService?.changeStatus( readState.entity, statusChangeEvent.targetStatus, null, callbackOptions.presetId )
							 : of( null );
			} )
		)
		.subscribe( ( statusChangedState: RequestCompleteEntityState<StatusFlowEntityType> ) => {
			if ( statusChangedState ) {
				this.toasterService.dispatch(
					statusChangedState,
					entityId,
					statusChangeEvent.requestActionStatus
				);

				if ( statusChangedState.requestState === RequestState.SUCCESS ) {
					entityService.storeUpsertOne( statusChangedState.entity );
					callback(
						entityService,
						{
							...callbackOptions,
							entity: statusChangedState.entity,
							caller: `${ caller }->${ entityId }:StatusFlow.changeStatus:`
						},
						callbackOptions.presetId
					);
				}
			}

			this.uiService.hidePageLoaderOrCountDown();
		} );
	}
}

